import type { ICellRendererComp, ICellRendererParams, ColDef } from "ag-grid-enterprise";

/**
 * Renders `data[field + "_multiline"]` (if present) as separate lines via real <br> elements,
 * falling back to `params.value` otherwise — same parallel-field pattern as StatusCellRenderer's
 * `field + "_html"`. Keeps the underlying value single-line for filtering/export/sort.
 */
export class MultilineTextCellRenderer implements ICellRendererComp {
  private eGui!: HTMLElement;

  init(params: ICellRendererParams): void {
    // A block element, not inline — otherwise AG-Grid's tall single-line ancestor still
    // governs each line's height via the CSS "strut", regardless of our own line-height.
    this.eGui = document.createElement("div");
    this.eGui.style.lineHeight = "normal";

    const field = (params.colDef as ColDef)?.field ?? "";
    const data = params.data as Record<string, unknown>;
    const multiline = field ? (data?.[`${field}_multiline`] as string | undefined) : undefined;
    const value = multiline ?? (params.value as string | null | undefined) ?? "";

    value.split("\n").forEach((line, index) => {
      if (index > 0) this.eGui.appendChild(document.createElement("br"));
      this.eGui.appendChild(document.createTextNode(line));
    });
  }

  getGui(): HTMLElement {
    return this.eGui;
  }

  refresh(): boolean {
    return false;
  }
}
